// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs
$(document).foundation();

// document ready method
$(function() {
  // TRIGGERMENU
  const header = document.querySelector('.page-header'),
    footer = document.querySelector('.page-footer'),
    body = document.body;
  const menuTrigger = document.querySelector('.menuTrigger');
  if (menuTrigger)
    menuTrigger.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      const pageContentWrap = document.querySelector('.page-content .pc-wrap'),
        headerWrap = header.querySelector('.ph-inner'),
        footerWrap = footer.querySelector('.pf-inner');

      // fix for the scrollbar missing - put a padding-right of the size of the scrollbar
      const paddingRight = !body.classList.contains('menu-opened')
        ? window.innerWidth -
          (document.documentElement.clientWidth || document.body.clientWidth) +
          'px'
        : '';
      [headerWrap, pageContentWrap].forEach(
        item => !item || (item.style.paddingRight = paddingRight)
      );
      if (footerWrap) footerWrap.style.paddingRight = paddingRight;

      body.classList.toggle('menu-opened');
      menuTrigger.classList.toggle('active');
    });
  //
  //
  // // close the menu when we click outside it, on the overlay
  // const menuWrapper = header.querySelector('.menu-wrapper'), menuWrapperParent = menuWrapper.parentNode;
  // menuWrapperParent.addEventListener('click', e => {
  //   if (window.innerWidth >= 768 ) {
  //     if ( document.body.classList.contains('menu-opened') && !menuWrapper.contains(e.target) ) {
  //       menuTrigger.click();
  //     }
  //   }
  // });
  //
  //
  // // SCROLL TO NEXT SECTION
  // document.addEventListener('click', e => {
  //   const scrollToNext = e.target.closest('.scroll-to-next-section');
  //   if (scrollToNext) {
  //     e.preventDefault();
  //     const thisSection = scrollToNext.closest('section');
  //     if (thisSection) {
  //       let found = false, current = thisSection.nextElementSibling;
  //       do {
  //         if (current.matches('section')) {
  //           found = true;
  //           const scrollTop = current.getBoundingClientRect().top + window.pageYOffset;
  //           $('html, body').animate({
  //             scrollTop
  //           }, 1000);
  //         }
  //         current = current.nextElementSibling;
  //       } while (!found && current);
  //     }
  //   }
  // });
  //

  // $('.home-slider-section').slick({
  // 	slidesToShow: 1,
  // 	infinite: true,
  // 	dots: false,
  // 	arrows: true,
  // 	speed: 1000,
  // 	fade: true,
  // 	autoplay: true,
  // 	autoplaySpeed: 5000,
  // });

  // $('.home-slider-section').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  // 	var $current = $(slick.$slides[currentSlide]).find('video');

  // 	$('.home-slider-section').slick('slickPause');
  // });

  // $('.home-slider-section').on('afterChange', function(event, slick, currentSlide, nextSlide){
  //   var $current = $(slick.$slides[currentSlide]).find('video');

  //   if ($current){

  //     $current.trigger('play');
  //   }
  // });

  $('.home-slider-section').slick({
    slidesToShow: 1,
    infinite: true,
    dots: false,
    arrows: true,
    speed: 1000,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $('.news-slider-mobile').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1023,
        settings: 'unslick',
      },
    ],
  });

  // $('.pages-posts-section .grid-x').slick({
  // 	dots: true,
  // 	infinite: true,
  // 	slidesToShow: 1,
  // 	slidesToScroll: 1,
  // 	mobileFirst: true,
  // 	arrows: false,

  // 	responsive: [
  // 		{
  // 			breakpoint: 768,
  // 			settings: {
  // 				slidesToShow: 2,
  // 				slidesToScroll: 1
  // 			}
  // 		},
  // 		{
  // 			breakpoint: 1024,
  // 			settings: "unslick"
  // 		}
  // 	]
  // });

  // MATCH-HEIGHT
  $('.js-eh').matchHeight();
  $('.js-eh-1').matchHeight();
  $('.news-slider-mobile .slick-slide article').matchHeight();
  $('.news-slider-mobile .slick-slide .text').matchHeight();
  $('.pages-posts-section .page-wrapper').matchHeight();

  $(document).on('click', '.content-switch', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let $p = $(this).parent('');
    $p.toggleClass('opened');
    // $p.find('header.entry-header').toggleClass('opened');
  });
});
